"use client";

import { usePathname } from "next/navigation";
import React from "react";
import { SidebarMenuButton } from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";

type Props = {
  /**
   * このパスの場合、isActiveがtrueになる
   */
  activePath?: string;
  /**
   * このパターンに一致するパスの場合、isActiveがtrueになる
   */
  activePattern?: string;
} & Omit<React.ComponentProps<typeof SidebarMenuButton>, "isActive">;

/**
 * SidebarMenuButtonのisActiveをpathnameによって判定するラッパー
 */
export default function SidebarMenuButtonWithPath({
  activePath,
  activePattern,
  ...props
}: Props) {
  const pathname = usePathname();
  const isActive = activePath
    ? pathname === activePath
    : activePattern
      ? new RegExp(activePattern).test(pathname)
      : false;
  return (
    <SidebarMenuButton
      isActive={isActive}
      {...props}
      className={cn(
        props.className,
        isActive && "bg-primary/10! text-primary! [&_svg]:text-primary!",
      )}
    />
  );
}
